<ng-container *ngIf="state$ | async as state">

    <h2 mat-dialog-title class="pv-dialog-title">
        <mat-icon class="material-symbols-outlined">graph_5</mat-icon>
        <span class="pv-dialog-title-text">Edit Index Component</span>
        <button mat-icon-button class="pv-dialog-close" (click)="cancel()" matTooltip="Close" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <!-- LOADING: white card loader while options load -->
    <div class="pv-dialog-loading" *ngIf="state.status === Status.LOADING; else readyTpl">
        <pv-spinner message="Loading options…" fill="white"></pv-spinner>
    </div>

    <ng-template #readyTpl>
        <mat-dialog-content class="pv-dialog-body">
            <form id="report_index_component_form"
                [formGroup]="formGroup"
                (ngSubmit)="attempt()"
                autocomplete="off"
            >

                <div class="field-block">
                    <label class="field-label">Index label</label>
                    <mat-form-field appearance="outline" class="full-width">
                        <input matInput type="text" formControlName="label" autocomplete="off">
                        <mat-error>Label max 40 chars</mat-error>
                    </mat-form-field>
                </div>

                <div class="two-col">
                    <div class="field-block">
                        <label class="field-label">Chart type</label>
                        <div class="chip-row">
                            <button type="button" *ngFor="let chartType of chartTypeOptions"
                                    class="opt-chip"
                                    [class.active]="typeControl.value === chartType.value"
                                    [attr.aria-pressed]="typeControl.value === chartType.value"
                                    [matTooltip]="chartType.label"
                                    (click)="setFormValue(typeControl, chartType.value); $event.preventDefault();">
                                <mat-icon class="material-symbols-outlined">{{ chartType.icon }}</mat-icon>
                                <span>{{ chartType.label }}</span>
                            </button>
                        </div>
                    </div>

                    <div class="field-block">
                        <label class="field-label">Context</label>
                        <div class="chip-row">
                            <button type="button" *ngFor="let option of chartContextOptions"
                                    class="opt-chip"
                                    [class.active]="contextControl.value === option.value"
                                    [attr.aria-pressed]="contextControl.value === option.value"
                                    (click)="setFormValue(contextControl, option.value); $event.preventDefault();">
                                <span>{{ option.label }}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="field-block">
                    <label class="field-label">Characteristics</label>
                    <pv-filter-search
                        [options]="state.characteristics"
                        [formControl]="charsControl"
                        dataLabel="Characteristics"
                        searchLabel="label"
                        [multiple]="true"
                    >
                    </pv-filter-search>
                </div>

                <div class="field-block">
                    <label class="field-label">Data points
                        <span class="field-label-hint">— drag to reorder, set weights, tick to mark negative</span>
                    </label>
                    <pv-dp-reorder-list
                        [formArray]="dataPointsArray"
                        [itemTemplate]="dpItemTemplate"
                        [extrasTemplate]="dpExtrasTemplate"
                        [itemClassFn]="negativeItemClass"
                    ></pv-dp-reorder-list>
                    <ng-template #dpItemTemplate let-dataPoint>
                        <span class="dp-name">{{ dataPoint.value.id | describeIndexDataPoint : dataPoint.value.type }}</span>
                    </ng-template>
                    <ng-template #dpExtrasTemplate let-dataPoint>
                        <label class="dp-weight">
                            Wt
                            <input type="number" [formControl]="dataPoint.controls.weight" min="1" max="100" required>
                        </label>
                        <mat-checkbox color="warn" [formControl]="dataPoint.controls.isNegative" matTooltip="Negative trait"></mat-checkbox>
                    </ng-template>
                </div>
            </form>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="pv-dialog-footer">
            <button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
            <button type="button" mat-flat-button color="primary" (click)="attempt()">
                <mat-icon>check</mat-icon>
                Apply
            </button>
        </mat-dialog-actions>
    </ng-template>

</ng-container>
